document.addEventListener('DOMContentLoaded', () => {
  if (!window.B2B?.enabled) return;

  const box = document.getElementById('b2b-bonus-box');
  if (!box) return;

  const qtyBlock = document.querySelector(
    '.product-single__box__block--quantity_selector'
  );
  if (qtyBlock) qtyBlock.insertAdjacentElement('afterend', box);

  function getGrams() {
    const checked = document.querySelector('input[name="Gramaj"]:checked');
    return checked ? parseInt(checked.value, 10) : null;
  }

  function getQty() {
    const input = document.querySelector('input[name="quantity"]');
    return input ? parseInt(input.value, 10) : null;
  }

  function update() {
    const bonusKg = window.B2BUtils.calculateBonusKg({
      grams: getGrams(),
      quantity: getQty()
    });

    if (bonusKg > 0) {
      box.innerHTML = `🎁 <strong>Bonus B2B: +${bonusKg}kg</strong>`;
      box.style.display = 'block';
    } else {
      box.style.display = 'none';
    }
  }

  update();
  document.addEventListener('change', update);
  document.addEventListener('input', update);
  document.addEventListener('click', update);
});